"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorTierWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var PremiumTypeSwitchWidget_1 = require("./PremiumTypeSwitchWidget");
var AnnualMotorTierTableWidget_1 = require("./tierTable/AnnualMotorTierTableWidget");
var AnnualMotorTierUpgradeModalConditions_1 = require("../../../helpers/annual/motor/AnnualMotorTierUpgradeModalConditions");
var AnnualMotorTierUpgradeModals_1 = require("../../../helpers/annual/motor/AnnualMotorTierUpgradeModals");
var NoPriceForMotorTierModal_1 = require("./NoPriceForMotorTierModal");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var AnnualMotorTierWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorTierWidget, _super);
    function AnnualMotorTierWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleNoPriceForTierModal = function () {
            _this.setState({
                showNoPriceForTierModal: !_this.state.showNoPriceForTierModal
            });
        };
        _this.state = {
            showModalEssentialsGHCSelected: false,
            showModalEssentialsGHCTotalLossSelected: false,
            showModalEssentialsMLESelected: false,
            showModalSilverMLESelected: false,
            showModalSilverGHCSelected: false,
            showModalEssentialsGHCAndMLESelected: false,
            showModalSilverGHCAndMLESelected: false,
            showNoPriceForTierModal: false,
            isEnhancedCourtesyCarAdditionPending: false,
            initialTier: _this.props.interaction.coverTier,
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleAddonChangeEvent = _this.handleAddonChangeEvent.bind(_this);
        _this.switchPremiumType = _this.switchPremiumType.bind(_this);
        _this.switchTier = _this.switchTier.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.navigateToEditRenewal = _this.navigateToEditRenewal.bind(_this);
        _this.useOnlyCourtesyCarTotalLoss = _this.getSetting("useOnlyCourtesyCarTotalLoss", false);
        return _this;
    }
    AnnualMotorTierWidget.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.props.interaction.uistate.previousCoverTier) {
                    journey_services_1.ObjectManipulator.setField("uistate.previousCoverTier", this.props.interaction, this.props.interaction.coverTier);
                }
                return [2 /*return*/];
            });
        });
    };
    AnnualMotorTierWidget.prototype.render = function () {
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        var windscreenCoverSettings = {
            includedInLowestTier: this.getSetting("windscreenCoverIncludedInLowestTier", true),
            includedInMidTier: this.getSetting("windscreenCoverIncludedInMidTier", true),
            includedInTopTier: this.getSetting("windscreenCoverIncludedInTopTier", true),
            showInAdditionalCoverDetails: this.getSetting("showWindscreenCoverInAdditionalCoverDetails", true),
        };
        if (eligibleTiers && eligibleTiers.length < 2) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        else {
            var showPremiumTypeSwitch = this.props.process === services_1.INTERACTION_PROCESS_NB
                || this.isMTCRenewal()
                || this.props.process === services_1.INTERACTION_PROCESS_MTC
                || this.props.process === services_1.INTERACTION_PROCESS_RENEWAL;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "annual-tier-widget", children: [this.getHeader(), showPremiumTypeSwitch && services_1.InteractionHelper.isMonthlyQuoteAllowed(this.props.interaction) &&
                        (0, jsx_runtime_1.jsx)(PremiumTypeSwitchWidget_1.PremiumTypeSwitchWidget, { interaction: this.props.interaction, executePremiumChange: this.switchPremiumType }), (0, jsx_runtime_1.jsx)(AnnualMotorTierTableWidget_1.AnnualMotorTierTableWidget, { interaction: this.props.interaction, interactionField: this.props.question.interactionField, useOnlyCourtesyCarTotalLoss: this.useOnlyCourtesyCarTotalLoss, onAddonChange: this.handleAddonChangeEvent, handleChange: this.handleChange, windscreenCoverSettings: windscreenCoverSettings }), this.renderIncludedTaxSection(), (0, AnnualMotorTierUpgradeModals_1.getAnnualMotorTierUpgradeModals)(this.state, this.switchTier, this.closeModal, this.bindFromField.bind(this)), (0, jsx_runtime_1.jsx)(NoPriceForMotorTierModal_1.default, { closeModal: this.toggleNoPriceForTierModal, isOpen: this.state.showNoPriceForTierModal, isNB: this.props.process === services_1.INTERACTION_PROCESS_NB, interaction: this.props.interaction })] }));
        }
    };
    AnnualMotorTierWidget.prototype.getHeader = function () {
        var _a, _b, _c;
        var isMonthly = ((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors.premiumType) === services_1.PREMIUM_TYPE_MONTHLY;
        var previousPremium = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
            this.props.interaction.factors.annualPremium : this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        var prevPremiumIsNotSet = previousPremium === 0 || previousPremium === null;
        var isMta = ((_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.status) === services_1.INTERACTION_STATUS_PENDING_MTA;
        var isMtc = this.isMTC();
        return (((_c = this.props.interaction) === null || _c === void 0 ? void 0 : _c.source) || isMta) ?
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-blue-2 quote-section-title", children: "Choose the cover that's right for you" }), !isMtc && (0, jsx_runtime_1.jsx)("p", { className: "quote-section-description font-weight-bold", children: this.getQuoteDescriptionWording() }), (isMta && !isMtc) && (0, jsx_runtime_1.jsxs)("p", { children: ["See below your ", isMonthly ? "monthly" : "annual", " price if you'd selected this cover level ", !prevPremiumIsNotSet ? "from the start of your policy." : "last year."] })] }) :
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-blue-2 quote-section-title", children: "Choose the cover that's right for you" }), !isMtc && (0, jsx_runtime_1.jsx)("p", { className: "quote-section-description font-weight-bold", children: this.getQuoteDescriptionWording() })] });
    };
    AnnualMotorTierWidget.prototype.getQuoteDescriptionWording = function () {
        if (services_1.resourcesHelper.THEME === "Britannia") {
            return;
        }
        return (0, commonFunctions_1.getEligibleTiers)(this.props.interaction).length === 2 ?
            "With just two levels to choose from, it\u2019s easy to select the ".concat(services_1.resourcesHelper.PRODUCT, " Car Insurance cover you need.") :
            "With three levels to choose from, it\u2019s easy to select the ".concat(services_1.resourcesHelper.PRODUCT, " Car Insurance cover you need.");
    };
    AnnualMotorTierWidget.prototype.isMTCRenewal = function () {
        var referrerJourney = this.getSetting("referrerJourney", "");
        return referrerJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
    };
    AnnualMotorTierWidget.prototype.isMTC = function () {
        var referrerJourney = this.getSetting("referrerJourney", "");
        return referrerJourney === services_1.INTERACTION_PROCESS_MTC;
    };
    AnnualMotorTierWidget.prototype.renderIncludedTaxSection = function () {
        var premiumType = this.props.interaction.factors.premiumType;
        return ((0, jsx_runtime_1.jsx)("div", { className: "included-tax-section margin-top-80", children: (0, jsx_runtime_1.jsxs)("p", { children: ["*All figures include ", premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                        'Insurance Premium Tax' : 'Interest and Insurance Premium Tax'] }) }));
    };
    AnnualMotorTierWidget.prototype.navigateToEditRenewal = function () {
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        this.props.engine.navigate("viewAndEditRenewalProposalPage", false);
    };
    AnnualMotorTierWidget.prototype.handleChange = function (selectedTier) {
        if ((0, commonFunctions_1.hasPriceForTier)(selectedTier, this.props.interaction.coverTier, this.props.interaction.tieredFactors)) {
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges(this.props.question.interactionField, selectedTier, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, selectedTier);
            this.changelogRecorder.recordQuestion("change", this.props);
            this.executeEvent("change");
        }
        else {
            this.toggleNoPriceForTierModal();
        }
    };
    AnnualMotorTierWidget.prototype.switchPremiumType = function () {
        var _this = this;
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        var tieredFactors = this.props.interaction.tieredFactors;
        if (tieredFactors.length > 0) {
            tieredFactors.forEach(function (factors, index) {
                _this.props.onStateChange("tieredFactors[".concat(index, "].premiumType"), newPremiumType);
            });
        }
        this.props.onStateChange("factors.premiumType", newPremiumType);
        journey_services_1.ObjectManipulator.setFieldWithTrackChanges("factors.premiumType", newPremiumType, {
            interaction: this.props.interaction,
            initialInteraction: this.props.initialInteraction,
        });
    };
    AnnualMotorTierWidget.prototype.handleAddonChangeEvent = function (event, addonField, addonValue) {
        if (this.shouldOpenGuaranteedHireCarUpgradeModal(addonField, addonValue)) {
            return;
        }
        var removeBreakdownCover = addonField === "optionalExtras.breakdownCover" && addonValue;
        var isEnhancedCourtesyCar = addonField === "optionalExtras.courtesyCarTotalLoss" &&
            this.props.interaction.uistate.isEligibleForEnhancedCourtesyCar &&
            this.useOnlyCourtesyCarTotalLoss;
        var removeEnhancedCourtesyCar = isEnhancedCourtesyCar && addonValue;
        var addEnhancedCourtesyCar = isEnhancedCourtesyCar && !addonValue;
        var addBreakdownCover = addonField === "optionalExtras.breakdownCover" && !addonValue;
        var isRemoveAddonWithLevelsAction = removeBreakdownCover || removeEnhancedCourtesyCar;
        var isNotAddAddonWithLevelsAction = !addBreakdownCover && !addEnhancedCourtesyCar;
        if (isNotAddAddonWithLevelsAction || isRemoveAddonWithLevelsAction) {
            if (removeBreakdownCover) {
                journey_services_1.ObjectManipulator.setField("optionalExtras.breakdownCoverLevel", this.props.interaction, null);
            }
            if (removeEnhancedCourtesyCar) {
                journey_services_1.ObjectManipulator.setField("optionalExtras.courtesyCarLevel", this.props.interaction, null);
            }
            journey_services_1.ObjectManipulator.setField("uistate.tierOptionalExtrasChanged", this.props.interaction, true);
        }
        this.handleAddAddonWithLevelAction(addBreakdownCover, addEnhancedCourtesyCar);
        this.props.onStateChange(addonField, !addonValue);
        this.validateQuestionFromPageValidators(addonField);
        !addonValue ? !this.showModal() && this.executeEvent("blur") : this.executeEvent("blur");
    };
    AnnualMotorTierWidget.prototype.handleAddAddonWithLevelAction = function (addBreakdownCover, addEnhancedCourtesyCar) {
        if (addBreakdownCover) {
            journey_services_1.ObjectManipulator.setField("uistate.isBreakdownCoverModalOpenForEditing", this.props.interaction, true);
        }
        if (addEnhancedCourtesyCar) {
            journey_services_1.ObjectManipulator.setField("uistate.isCourtesyCarModalOpenForEditing", this.props.interaction, true);
        }
    };
    AnnualMotorTierWidget.prototype.showModal = function (overrides) {
        var conditions = (0, AnnualMotorTierUpgradeModalConditions_1.getModalConditions)(this.getBindWithOverrides(overrides), this.props.interaction, this.useOnlyCourtesyCarTotalLoss);
        var _loop_1 = function (condition) {
            if (!condition.isModalShown && condition.conditionCheck()) {
                this_1.setState(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[condition.stateKey] = true, _a)));
                });
                journey_services_1.ObjectManipulator.setField(condition.uiStateKey, this_1.props.interaction, true);
                return { value: true };
            }
        };
        var this_1 = this;
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var state_1 = _loop_1(condition);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    AnnualMotorTierWidget.prototype.closeModal = function (modalStateKey, shouldShowEnhancedCourtesyCarSelectModal) {
        if (shouldShowEnhancedCourtesyCarSelectModal === void 0) { shouldShowEnhancedCourtesyCarSelectModal = true; }
        var shouldAddEnhancedCourtesyCar = this.state.isEnhancedCourtesyCarAdditionPending;
        this.setState(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[modalStateKey] = false, _a.isEnhancedCourtesyCarAdditionPending = false, _a)));
        });
        if (shouldAddEnhancedCourtesyCar && shouldShowEnhancedCourtesyCarSelectModal) {
            journey_services_1.ObjectManipulator.setField("uistate.isCourtesyCarModalOpenForEditing", this.props.interaction, true);
            this.props.onStateChange("optionalExtras.courtesyCarTotalLoss", true);
        }
        this.executeEvent("blur");
    };
    AnnualMotorTierWidget.prototype.switchTier = function (tier, modalStateKey) {
        journey_services_1.ObjectManipulator.setFieldWithTrackChanges("coverTier", tier, {
            interaction: this.props.interaction,
            initialInteraction: this.props.initialInteraction,
        });
        journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, tier);
        this.changelogRecorder.recordQuestion("change", this.props);
        this.closeModal(modalStateKey, !this.state.isEnhancedCourtesyCarAdditionPending);
    };
    AnnualMotorTierWidget.prototype.shouldOpenGuaranteedHireCarUpgradeModal = function (addonField, addonValue) {
        var isCourtesyCarAdd = addonField === "optionalExtras.courtesyCarTotalLoss" && !addonValue;
        if (!isCourtesyCarAdd) {
            return false;
        }
        if (!this.props.interaction.uistate.isEligibleForEnhancedCourtesyCar) {
            return false;
        }
        var shouldShowUpgradeModal = this.showModal({
            "optionalExtras.courtesyCarTotalLoss": true,
        });
        if (shouldShowUpgradeModal) {
            this.setState({ isEnhancedCourtesyCarAdditionPending: true });
        }
        return shouldShowUpgradeModal;
    };
    AnnualMotorTierWidget.prototype.getBindWithOverrides = function (overrides) {
        var _this = this;
        return function (field) {
            if (overrides && field in overrides) {
                return overrides[field];
            }
            return _this.bindFromField(field);
        };
    };
    AnnualMotorTierWidget.prototype.validateQuestionFromPageValidators = function (field) {
        var validationQuestionName = field.replace("optionalExtras.", "");
        this.props.engine.validateQuestion(validationQuestionName);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualMotorTierWidget.prototype, "changelogRecorder", void 0);
    return AnnualMotorTierWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorTierWidget = AnnualMotorTierWidget;
//# sourceMappingURL=AnnualMotorTierWidget.js.map